 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1SKYDYNASTYBANDIT from '@/components/0_chapter1skydynastybandit'
 import A_CHAPTER2GREATDESERTCITY from '@/components/1_chapter2greatdesertcity'
 import A_CHAPTER3ADREAMOFSNOWANDWIND from '@/components/2_chapter3adreamofsnowandwind'
 import A_CHAPTER4ALLNOTHINGNESS from '@/components/3_chapter4allnothingness'
 import A_CHAPTER5BURLYMAN from '@/components/4_chapter5burlyman'
 import A_CHAPTER6COMMONCALABASHHERB from '@/components/5_chapter6commoncalabashherb'
 import A_CHAPTER7TOXICDRAGONINTOGU from '@/components/6_chapter7toxicdragonintogu'
 import A_CHAPTER8EXTREMELYGOODSWORDWINSEVIL from '@/components/7_chapter8extremelygoodswordwinsevil'
 import A_CHAPTER9ASNOWYNIGHTAFORTUITOUSENCOUNTER from '@/components/8_chapter9asnowynightafortuitousencounter'
 import A_CHAPTER10WINDFLYINGARROW from '@/components/9_chapter10windflyingarrow'
 import A0_CHAPTER11HUNNUANDHAN from '@/components/10_chapter11hunnuandhan'
 import A1_CHAPTER12HEMIFACIALJUNCTION from '@/components/11_chapter12hemifacialjunction'
 import A2_CHAPTER13NANKOUSDREAM from '@/components/12_chapter13nankousdream'
 import A3_CHAPTER14IMMORTALLEGEND from '@/components/13_chapter14immortallegend'
 import A4_CHAPTER15CENTENNIALUNION from '@/components/14_chapter15centennialunion'
 import A5_CHAPTER16DESERTDUST from '@/components/15_chapter16desertdust'
 import A6_CHAPTER17SHANSANGENERAL from '@/components/16_chapter17shansangeneral'
 import A7_CHAPTER18IMPERIALPALACE from '@/components/17_chapter18imperialpalace'
 import A8_CHAPTER19UNBELIEVABLE from '@/components/18_chapter19unbelievable'
 import A9_CHAPTER20BEYONDTHEREACHOFAWHIP from '@/components/19_chapter20beyondthereachofawhip'
 import A0_CHAPTER21CHOUSENEMY from '@/components/20_chapter21chousenemy'
 import A1_CHAPTER22PHOEBE from '@/components/21_chapter22phoebe'
 import A2_CHAPTER23FIVESPIRITSOFTHEDESERT from '@/components/22_chapter23fivespiritsofthedesert'
 import A3_CHAPTER24WHITEHEADEDBEGGAR from '@/components/23_chapter24whiteheadedbeggar'
 import A4_CHAPTER25CAMEL from '@/components/24_chapter25camel'
 import A5_CHAPTER26TRANSCENDENTALCHILD from '@/components/25_chapter26transcendentalchild'
 import A6_CHAPTER27IDENTITYDISPARITY from '@/components/26_chapter27identitydisparity'
 import A7_CHAPTER28GREATDISAPPOINTMENT from '@/components/27_chapter28greatdisappointment'
 import A8_CHAPTER29TWINCHILD from '@/components/28_chapter29twinchild'
 import A9_CHAPTER30DIFFICULTTODO from '@/components/29_chapter30difficulttodo'
 import A0_CHAPTER31KINGSSWORD from '@/components/30_chapter31kingssword'
 import A1_CHAPTER32HONGMENEVENINGFEAST from '@/components/31_chapter32hongmeneveningfeast'
 import A2_CHAPTER33BLOODYWARATTHEINN from '@/components/32_chapter33bloodywarattheinn'
 import A3_CHAPTER34SOLITARYTOWERSUNDERTHEMOON from '@/components/33_chapter34solitarytowersunderthemoon'
 import A4_CHAPTER35WESTFIRETOWER from '@/components/34_chapter35westfiretower'
 import A5_CHAPTER36CONGENIALNATURE from '@/components/35_chapter36congenialnature'
 import A6_CHAPTER37WHATSAFTER from '@/components/36_chapter37whatsafter'
 import A7_CHAPTER38LEFTANDRIGHTALIMENTARYCANAL from '@/components/37_chapter38leftandrightalimentarycanal'
 import A8_CHAPTER39BIRTHANDREBIRTH from '@/components/38_chapter39birthandrebirth'
 import A9_CHAPTER40ANENIGMA from '@/components/39_chapter40anenigma'
 import A0_CHAPTER41ENVIOUSHEART from '@/components/40_chapter41enviousheart'
 import A1_CHAPTER42MODAO from '@/components/41_chapter42modao'
 import A2_CHAPTER43BROTHERLYGRUDGES from '@/components/42_chapter43brotherlygrudges'
 import A3_CHAPTER44LOVEATFIRSTSIGHT from '@/components/43_chapter44loveatfirstsight'
 import A4_CHAPTER45FORTUITOUSENCOUNTERINWANGCUN from '@/components/44_chapter45fortuitousencounterinwangcun'
 import A5_CHAPTER46THEYBROUGHTTHEBLAMEUPONTHEMSELVES from '@/components/45_chapter46theybroughttheblameuponthemselves'
 import A6_CHAPTER47SHIJIAJIE from '@/components/46_chapter47shijiajie'
 import A7_CHAPTER48CURSEANDPOISON from '@/components/47_chapter48curseandpoison'
 import A8_CHAPTER49IMMORTALITY from '@/components/48_chapter49immortality'
 import A9_CHAPTER50IMPERMEABILITYOFAHUNDREDPOISONS from '@/components/49_chapter50impermeabilityofahundredpoisons'
 import A0_CHAPTER51BIGMANHEAVENLYSOLDIER from '@/components/50_chapter51bigmanheavenlysoldier'
 import A1_CHAPTER52FULLYASSEMBLEDANDREADYTOGO from '@/components/51_chapter52fullyassembledandreadytogo'
 import A2_CHAPTER53DEPARTURE from '@/components/52_chapter53departure'
 import A3_CHAPTER54DISPIRITEDMIND from '@/components/53_chapter54dispiritedmind'
 import A4_CHAPTER55RELIEF from '@/components/54_chapter55relief'
 import A5_CHAPTER56OTHERREASONS from '@/components/55_chapter56otherreasons'
 import A6_CHAPTER57DIFFICULTIESINFINDINGAFOOTHOLD from '@/components/56_chapter57difficultiesinfindingafoothold'
 import A7_CHAPTER58MILITARYNEUTRALITY from '@/components/57_chapter58militaryneutrality'
 import A8_CHAPTER59OLDHANDICAPPEDSOLDIER from '@/components/58_chapter59oldhandicappedsoldier'
 import A9_CHAPTER60ONEARROWDETERMININGTHEUNIVERSE from '@/components/59_chapter60onearrowdeterminingtheuniverse'
 import A0_CHAPTER61LOYALTYISDIFFICULT from '@/components/60_chapter61loyaltyisdifficult'
 import A1_CHAPTER62CAPITALRESIDENCEOFTHEWESTERNREGIONS from '@/components/61_chapter62capitalresidenceofthewesternregions'
 import A2_CHAPTER63REINSTATETHEWESTERNREGIONS from '@/components/62_chapter63reinstatethewesternregions'
 import A3_CHAPTER64JADESHADOWSERIES from '@/components/63_chapter64jadeshadowseries'
 import A4_CHAPTER65SINGLESHADOWONLY from '@/components/64_chapter65singleshadowonly'
 import A5_CHAPTER66OCCULTATION from '@/components/65_chapter66occultation'
 import A6_CHAPTER67TIGERSEEDPOWER from '@/components/66_chapter67tigerseedpower'
 import A7_CHAPTER68QUESTSTARKICK from '@/components/67_chapter68queststarkick'
 import A8_CHAPTER69ALIE from '@/components/68_chapter69alie'
 import A9_CHAPTER70WINDWITHOUTTRACE from '@/components/69_chapter70windwithouttrace'
 import A0_CHAPTER71QUADRIPLEGIA from '@/components/70_chapter71quadriplegia'
 import A1_CHAPTER72PRINCESSESFRESH from '@/components/71_chapter72princessesfresh'
 import A2_CHAPTER73OPENHEARTANDFASTMOUTH from '@/components/72_chapter73openheartandfastmouth'
 import A3_CHAPTER74THEREMUSTBEMYTEACHER from '@/components/73_chapter74theremustbemyteacher'
 import A4_CHAPTER75HOODLUM from '@/components/74_chapter75hoodlum'
 import A5_CHAPTER76UNINVITEDGUEST from '@/components/75_chapter76uninvitedguest'
 import A6_CHAPTER77TWOKILLERS from '@/components/76_chapter77twokillers'
 import A7_CHAPTER78TUOBA from '@/components/77_chapter78tuoba'
 import A8_CHAPTER79VENGEANCEPLAN from '@/components/78_chapter79vengeanceplan'
 import A9_CHAPTER80DEMONBODY from '@/components/79_chapter80demonbody'
 import A0_CHAPTER81DEFEATTHEENEMYWITHTHEGODLYSWORD from '@/components/80_chapter81defeattheenemywiththegodlysword'
 import A1_CHAPTER82HEXAGONALEXERCISE from '@/components/81_chapter82hexagonalexercise'
 import A2_CHAPTER83SURGE from '@/components/82_chapter83surge'
 import A3_CHAPTER84DUSTCOLLECTION from '@/components/83_chapter84dustcollection'
 import A4_CHAPTER85EMOTIONLESS from '@/components/84_chapter85emotionless'
 import A5_CHAPTER86THEFALLINGMOON from '@/components/85_chapter86thefallingmoon'
 import A6_CHAPTER87SHROUDINGSUNTREADINGONWIND from '@/components/86_chapter87shroudingsuntreadingonwind'
 import A7_CHAPTER88RIGHTANDWRONG from '@/components/87_chapter88rightandwrong'
 import A8_CHAPTER89LONELYCHILDHOOD from '@/components/88_chapter89lonelychildhood'
 import A9_CHAPTER90WINDANDMOON from '@/components/89_chapter90windandmoon'
 import A0_CHAPTER91WITHERINGRAIN from '@/components/90_chapter91witheringrain'
 import A1_CHAPTER92ENCLAVE from '@/components/91_chapter92enclave'
 import A2_CHAPTER93SURROUNDINGSONG from '@/components/92_chapter93surroundingsong'
 import A3_CHAPTER94THEREISAWORRYINMYHEART from '@/components/93_chapter94thereisaworryinmyheart'
 import A4_CHAPTER95GOLDENARMOREDGODLYGENERAL from '@/components/94_chapter95goldenarmoredgodlygeneral'
 import A5_CHAPTER96MEETINGOLDPEOPLE from '@/components/95_chapter96meetingoldpeople'
 import A6_CHAPTER97ENDEAVOURVALLEY from '@/components/96_chapter97endeavourvalley'
 import A7_CHAPTER98BLOODSTAINEDYELLOWSAND from '@/components/97_chapter98bloodstainedyellowsand'
 import A8_CHAPTER99BURIALSITE from '@/components/98_chapter99burialsite'
 import A9_CHAPTER100MOBEIWINDFROST from '@/components/99_chapter100mobeiwindfrost'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1skydynastybandit",
 			"name" : "0_chapter1skydynastybandit",
 			"component" : A_CHAPTER1SKYDYNASTYBANDIT
 		},
 		{
 			"path" : "/1_chapter2greatdesertcity",
 			"name" : "1_chapter2greatdesertcity",
 			"component" : A_CHAPTER2GREATDESERTCITY
 		},
 		{
 			"path" : "/2_chapter3adreamofsnowandwind",
 			"name" : "2_chapter3adreamofsnowandwind",
 			"component" : A_CHAPTER3ADREAMOFSNOWANDWIND
 		},
 		{
 			"path" : "/3_chapter4allnothingness",
 			"name" : "3_chapter4allnothingness",
 			"component" : A_CHAPTER4ALLNOTHINGNESS
 		},
 		{
 			"path" : "/4_chapter5burlyman",
 			"name" : "4_chapter5burlyman",
 			"component" : A_CHAPTER5BURLYMAN
 		},
 		{
 			"path" : "/5_chapter6commoncalabashherb",
 			"name" : "5_chapter6commoncalabashherb",
 			"component" : A_CHAPTER6COMMONCALABASHHERB
 		},
 		{
 			"path" : "/6_chapter7toxicdragonintogu",
 			"name" : "6_chapter7toxicdragonintogu",
 			"component" : A_CHAPTER7TOXICDRAGONINTOGU
 		},
 		{
 			"path" : "/7_chapter8extremelygoodswordwinsevil",
 			"name" : "7_chapter8extremelygoodswordwinsevil",
 			"component" : A_CHAPTER8EXTREMELYGOODSWORDWINSEVIL
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js